<div class="toolbar-break">
</div>
@if (faqPage) {
  <app-image class="hero-img" [prismicImage]="faqPage.hero_image" [bcimage]="true"></app-image>
  <div class="container">
    <div class="text-center text-md-start my-5">
      <h1>{{faqPage.title[0]?.text}}</h1>
      <div [innerHtml]="faqPage.faq_hero_body"></div>
    </div>
    <div class="row">
      <mat-accordion multi>
        @for (subpage of faqPage.faq_subpages; track subpage) {
          <h2>{{subpage.title}}</h2>
          @for (faq of subpage.faqs; track faq) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="faq-title">
                  {{faq.title}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>{{faq.text}}</p>
            </mat-expansion-panel>
          }
          <br />
          <br />
        }
      </mat-accordion>
    </div>
  </div>
}
